(function(){
  'use strict';
  if(window.__skpOfferV1)return;
  window.__skpOfferV1=true;

  var HEADERS={'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'};

  function rootPath(){return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';}

  /* Cart drawer open: same route the store's proven bundle block uses (renderContents on the theme's cart-drawer element). */
  function applySections(data){
    if(!data||!data.sections||!data.sections['cart-icon-bubble'])return;
    var bubble=document.getElementById('cart-icon-bubble');
    if(bubble)bubble.innerHTML=data.sections['cart-icon-bubble'];
  }

  function openDrawer(data){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer)return false;
    var ok=false;
    try{if(typeof drawer.renderContents==='function'){drawer.renderContents(data);ok=true;}}catch(e){ok=false;}
    if(!ok&&data&&data.sections&&data.sections['cart-drawer']){
      var holder=document.createElement('div');
      holder.innerHTML=data.sections['cart-drawer'];
      var fresh=holder.querySelector('.drawer__inner');
      var current=drawer.querySelector('.drawer__inner');
      if(fresh&&current)current.innerHTML=fresh.innerHTML;
    }
    drawer.classList.remove('is-empty');
    drawer.classList.add('active','animate');
    if(typeof drawer.open==='function'){try{drawer.open();}catch(e){}}
    document.body.classList.add('overflow-hidden');
    return true;
  }

  function drawerIsOpen(){
    var drawer=document.querySelector('cart-drawer');
    return !!(drawer&&drawer.classList.contains('active'));
  }

  function scrollToOffer(){
    var offer=document.getElementById('skp-offer');
    if(!offer)return;
    var bannerSpace=parseFloat(document.body.style.marginTop)||0;
    var top=offer.getBoundingClientRect().top+window.pageYOffset-bannerSpace-84;
    window.scrollTo({top:Math.max(0,top),behavior:'smooth'});
  }

  function initOffer(root){
    if(root.dataset.skpReady==='true')return;
    root.dataset.skpReady='true';
    var bars=Array.prototype.slice.call(root.querySelectorAll('[data-skp-bar]'));
    var submit=root.querySelector('[data-skp-submit]');
    var form=root.querySelector('[data-skp-form]');
    var error=root.querySelector('[data-skp-error]');
    var variantId=Number(root.dataset.variantId);
    var activeIndex=Number(root.dataset.defaultTier||1);
    var locked=false;

    function selectTier(index){
      activeIndex=index;
      bars.forEach(function(bar,i){
        var selected=i===index;
        bar.classList.toggle('skp-bar--selected',selected);
        var head=bar.querySelector('[data-skp-tier]');
        if(head)head.setAttribute('aria-checked',selected?'true':'false');
      });
      submit.textContent=bars[index].dataset.cta;
      if(error)error.hidden=true;
    }

    bars.forEach(function(bar,index){
      var head=bar.querySelector('[data-skp-tier]');
      if(head)head.addEventListener('click',function(){selectTier(index);});
    });

    form.addEventListener('submit',function(event){
      event.preventDefault();
      if(locked)return;
      var active=bars[activeIndex];
      var quantity=Number(active.dataset.count);
      if(!variantId||!quantity)return;
      locked=true;
      submit.disabled=true;
      submit.textContent='ADDING…';
      error.hidden=true;
      fetch(rootPath()+'cart/add.js?kaching_bundles=true',{
        method:'POST',
        headers:HEADERS,
        body:JSON.stringify({items:[{id:variantId,quantity:quantity}],sections:'cart-drawer,cart-icon-bubble',sections_url:rootPath()})
      }).then(function(response){
        if(!response.ok)throw new Error('cart add failed');
        return response.json();
      }).then(function(data){
        submit.textContent='ADDED';
        openDrawer(data);
        applySections(data);
        setTimeout(function(){locked=false;submit.disabled=false;submit.textContent=active.dataset.cta;},1400);
      }).catch(function(){
        locked=false;
        submit.disabled=false;
        submit.textContent=active.dataset.cta;
        error.hidden=false;
        error.textContent='We could not add it to your cart. Please try again.';
      });
    });

    selectTier(activeIndex);
  }

  /* Mobile sticky bar: visible only after the offer block has scrolled out of view above the screen,
     hidden while the offer block is on screen and while the cart drawer is open. */
  function initSticky(){
    var sticky=document.querySelector('[data-skp-sticky]');
    var offer=document.getElementById('skp-offer');
    if(!sticky||!offer||sticky.dataset.skpReady==='true')return;
    sticky.dataset.skpReady='true';
    var offerOnScreen=true;
    var offerPassed=false;

    function update(){
      sticky.hidden=!(offerPassed&&!offerOnScreen&&!drawerIsOpen());
    }

    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          offerOnScreen=entry.isIntersecting;
          offerPassed=entry.boundingClientRect.bottom<0;
        });
        update();
      },{threshold:0}).observe(offer);
    }else{
      window.addEventListener('scroll',function(){
        var rect=offer.getBoundingClientRect();
        offerOnScreen=rect.bottom>0&&rect.top<window.innerHeight;
        offerPassed=rect.bottom<0;
        update();
      },{passive:true});
    }

    var drawer=document.querySelector('cart-drawer');
    if(drawer&&'MutationObserver' in window){
      new MutationObserver(update).observe(drawer,{attributes:true,attributeFilter:['class']});
    }
  }

  /* Demo clips load and play only when they scroll into view (lazy, muted, looped). */
  function initClips(){
    var clips=Array.prototype.slice.call(document.querySelectorAll('[data-skp-clip]'));
    if(!clips.length)return;
    function start(video){
      if(!video.getAttribute('src'))video.setAttribute('src',video.dataset.src);
      video.muted=true;
      var played=video.play();
      if(played&&typeof played.catch==='function')played.catch(function(){});
    }
    if(!('IntersectionObserver' in window)){clips.forEach(start);return;}
    var watcher=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting)start(entry.target);else if(entry.target.getAttribute('src'))entry.target.pause();
      });
    },{rootMargin:'200px 0px',threshold:0});
    clips.forEach(function(video){
      if(video.dataset.skpReady==='true')return;
      video.dataset.skpReady='true';
      watcher.observe(video);
    });
  }

  function boot(){
    document.querySelectorAll('[data-skp-offer]').forEach(initOffer);
    initSticky();
    initClips();
  }

  document.addEventListener('click',function(event){
    var trigger=event.target.closest&&event.target.closest('[data-skp-scroll]');
    if(!trigger)return;
    event.preventDefault();
    scrollToOffer();
  });

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  window.addEventListener('load',boot,{once:true});
})();
